
import { Component, OnInit, Input, OnChanges, Output, AfterContentChecked, EventEmitter, } from '@angular/core';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { AttributeListBE } from '../shared/attribute-list.model';
import { SetFocus } from '../../app/shared/setFocus';

@Component({
    moduleId: module.id,
    selector: 'packaging-instruction-selectlist',
    templateUrl: 'packaging-instruction-selectlist.html',
    providers: [ErrorHandlerService],
    styleUrls: ['packaging-instruction.css']
})
export class PackagingInstructionSelectListComponent implements OnInit, AfterContentChecked, OnChanges {
    @Input() fetchDataFunction: any;
    @Input() data: AttributeListBE[];
    @Output() selectedId: EventEmitter<number> = new EventEmitter<number>();
 
    dataList: AttributeListBE[];
    searchText: string = "";
    viewList: boolean = false;
    searchKeyStrokeDelay: number = 350;
    typeDelayTimer: any = null;

    searchListDelayTimer: any = null;
    searchListDelayTimerDelay: number = 250;

    setFocus: SetFocus = new SetFocus();
    isFocusSet: boolean = false;

    constructor(private errHandler: ErrorHandlerService) {
    }

    ngOnInit(): void {
    }
     
    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to("searchListInput", this.isFocusSet);
    }

    ngOnChanges() {
        this.dataList = this.data;
    }

    searchTextChanged() {
        var that = this; // needed to preserve scope reference to this within setinterval function

        if (that.searchText.length >= 2) {
            that.viewList = true;

            // If this.typeDelayTimer is not nulll then the  
            // user typed somthing new within time limit so reset timer
            if (that.typeDelayTimer != null)
                clearInterval(that.typeDelayTimer);

            that.typeDelayTimer = setInterval(function () {
                that.fetchDataFunction(that.searchText);
                clearInterval(that.typeDelayTimer);
            }, that.searchKeyStrokeDelay);
        }
        else {
            that.viewList = false;
            clearInterval(that.typeDelayTimer);
        }
    }

    selectItem(id: number) {
        this.selectedId.emit(id);
        this.isFocusSet = this.setFocus.to("searchListInput", false);         
    }

    hideSearchListWithDelay() {
        clearInterval(this.searchListDelayTimer);
        this.startSearchListWithDelay();
    }

    finalizeHideSearchListWithDelay() {
        this.viewList = false;
        clearInterval(this.searchListDelayTimer);
    }

    startSearchListWithDelay() {
        var that = this;

        if (!that.viewList) {
            clearInterval(that.searchListDelayTimer);
            return;
        }

        if (that.searchListDelayTimer != null)
            clearInterval(that.searchListDelayTimer);

        that.searchListDelayTimer = setInterval(function () {
            that.finalizeHideSearchListWithDelay();
        }, that.searchListDelayTimerDelay);
    }

    showSearchList() {
        if (this.searchText.length >= 2) {
            clearInterval(this.searchListDelayTimer);
            this.viewList = true;
        }
    }

}




// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/packaging-instruction/packaging-instruction-selectlist.component.ts